<template>
  <div :class="['colors_wrapper', isSmallSize ? 'small' : '']">
    <div
      id="backgroundColorPicker"
      class="item__container"
    >
      <span> Background Color: </span>
      <div
        class="item bg__color"
        :style="{backgroundColor}"
        @click="onOpenPicker('bg')"
      >
        <color-picker-component
          v-if="isBgPickerOpened"
          :model="isBgPickerOpened"
          type="bg"
          :default-color="backgroundColor"
          @color-changed="onColorChange"
          @close-picker="closePicker"
        />
      </div>
    </div>

    <div
      id="textColorPicker"
      class="item__container"
    >
      <span>Text Color: </span>
      <div
        class="item text__color"
        :style="{backgroundColor: textColor}"
        @click="onOpenPicker('text')"
      >
        <color-picker-component
          v-if="isTextPickerOpened"
          :default-color="textColor"
          :model="isTextPickerOpened"
          type="text"
          @color-changed="onColorChange"
          @close-picker="closePicker"
        />
      </div>
    </div>
    <div
      v-if="borderColor"
      id="borderColorPicker"
      class="item__container"
    >
      <span>Border Color: </span>
      <div
        class="item text__color"
        :style="{backgroundColor: borderColor}"
        @click="onOpenPicker('border')"
      >
        <color-picker-component
          v-if="isBorderPickerOpened"
          :default-color="borderColor"
          :model="isBorderPickerOpened"
          type="border"
          @color-changed="onColorChange"
          @close-picker="closePicker"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ColorPickerComponent from '@/modules/DataManagement/views/designer/components/ColorPickerComponent.vue';

export default {
  name: 'ColorsEditorComponent',
  components: {ColorPickerComponent},
  props: [
    'textColor',
    'backgroundColor',
    'borderColor',
    'size',
  ],
  data() {
    return {
      isBgPickerOpened: false,
      isTextPickerOpened: false,
      isBorderPickerOpened: false,
    };
  },
  computed: {
    isSmallSize() {
      return this.size === 'small';
    },
  },
  methods: {
    onOpenPicker(type) {
      switch (type) {
      case 'bg':
        this.isBgPickerOpened = true;
        break;
      case 'text':
        this.isTextPickerOpened = true;
        break;
      default:
        this.isBorderPickerOpened = true;
        break;
      }
    },
    closePicker(type) {
      switch (type) {
      case 'bg':
        this.isBgPickerOpened = false;
        break;
      case 'text':
        this.isTextPickerOpened = false;
        break;
      default:
        this.isBorderPickerOpened = false;
        break;
      }
    },
    onColorChange({type, color}) {
      switch (type) {
      case 'bg':
        this.$emit('get-background-color', color);
        break;
      case 'text':
        this.$emit('get-text-color', color);
        break;
      default:
        this.$emit('get-border-color', color);
        break;
      }
    },
  },

};
</script>


<style scoped lang="scss">
.colors_wrapper {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 20px;

  &.small {
    padding-left: 0;
  }
}

.item__container {
  display: inherit;
  align-items: center;
  gap: 20px;
}

.item {
  position: relative;
  cursor: pointer;
  box-shadow: 0 0 15px #ccc;
  border-radius: 4px;
  height: 30px;
  width: 50px;
}
</style>